(() => {
  const dialog = document.getElementById('FFCampaignPopup');
  if (!dialog || dialog.hasAttribute('data-editor')) return;
  const end = Date.parse(dialog.dataset.ends);
  const key = `ff-campaign-seen:${dialog.dataset.campaign}`;
  let previousFocus;
  let shown = false;
  try { if (sessionStorage.getItem(key)) return; } catch {}
  const close = () => { if (dialog.open) dialog.close(); };
  dialog.querySelectorAll('button').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
  dialog.addEventListener('close', () => { if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true}); });
  const attempt = () => {
    if (!Number.isFinite(end) || Date.now() >= end || shown) return;
    const busy = Array.from(document.querySelectorAll('dialog[open],[role="dialog"],.cmplz-cookiebanner')).some(el => el !== dialog && el.getBoundingClientRect().width > 0 && el.getBoundingClientRect().height > 0 && getComputedStyle(el).visibility !== 'hidden');
    if (document.hidden || busy || document.activeElement?.matches('input,textarea,select')) { setTimeout(attempt, 2000); return; }
    previousFocus = document.activeElement;
    dialog.showModal();
    shown = true;
    try { sessionStorage.setItem(key, '1'); } catch {}
    const remaining = end - Date.now();
    if (remaining < 2147483647) setTimeout(close, remaining);
  };
  setTimeout(attempt, 8000);
})();
